// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2_1m5","select":"styles_select__HiZ4q"};